import React, { FC, useState, useEffect } from 'react'
import { makeStyles, Theme, Grid, Typography, Button } from '@material-ui/core'
import { useParams, Link } from 'react-router-dom'
import { ArrowBack, MailOutline } from '@material-ui/icons'

import { Video } from 'components/shared'
import { IDemo } from 'types'
import { Demos, Sessions } from 'helpers'

import { ReactComponent as ArrowRight } from 'assets/chevron-right.svg'

interface MobileDemoProps {
  isSession?: boolean
}
interface IParams {
  demoId: string
}

export const MobileDemo: FC<MobileDemoProps> = ({ isSession = false }) => {
  const { demoId } = useParams<IParams>()
  const classes = useStyles()
  const [demo, setDemo] = useState<IDemo>()

  useEffect(() => {
    if (demoId) {
      const foundDemo = isSession
        ? Sessions.find(session => session.id === demoId)
        : Demos.find(demo => demo.id === demoId)
      if (foundDemo) {
        setDemo(foundDemo)
      }
    }
    // eslint-disable-next-line
  }, [demoId, isSession])

  return (
    <div className={classes.root}>
      {demo && (
        <Grid container>
          <Grid item xs={12}>
            {demo.video && <Video videoSrc={demo.video} posterSrc={demo.poster} />}
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant='h2'
              component='h1'
              className={classes.heading}
              dangerouslySetInnerHTML={{ __html: demo.end?.header || '' }}
            />
          </Grid>
          {demo.end?.body && (
            <Grid item xs={12} className={classes.bodyText}>
              <Typography paragraph>
                <span dangerouslySetInnerHTML={{ __html: demo.end?.body }}></span>
              </Typography>
            </Grid>
          )}
          <Grid container item xs={12} justify='space-between' alignItems='center'>
            <Grid item>
              <Typography component='span' className={classes.nextText}>
                Next use case
              </Typography>
            </Grid>
            <Grid item>
              <Button
                component={Link}
                to={isSession ? '/event/dod-use-cases' : '/event/other-use-cases'}
                variant='text'
                className={classes.viewAllButton}
                endIcon={<ArrowRight />}
              >
                View all
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.nextVideoWrapper}>
            <img src={demo.end?.nextDemoThumbnail} alt={demo.end?.nextDemoText} className={classes.thumbnail} />
            <Link to={`/event/${isSession ? 'dod-use-cases' : 'other-use-cases'}/${demo.end?.nextDemoId}`}>
              <div className={classes.thumbnailOverlay}>
                <span
                  className={classes.nextDemoText}
                  dangerouslySetInnerHTML={{ __html: demo.end?.nextDemoText || '' }}
                />
              </div>
            </Link>
          </Grid>
          <Grid item container xs={12} justify='space-between' alignItems='center'>
            <Grid item>
              <Button
                component={Link}
                variant='text'
                to={`/event/${isSession ? 'dod-use-cases' : 'other-use-cases'}/${demo.end?.previousDemoId}`}
                startIcon={<ArrowBack />}
              >
                Back
              </Button>
            </Grid>

            <Grid item>
              <Button component={Link} variant='text' to={`/event/contact/${demo.id}`} startIcon={<MailOutline />}>
                Send a message
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}
    </div>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: '2rem'
  },
  heading: {
    margin: '1rem 0'
  },
  bodyText: {
    marginBottom: '1rem',
    borderBottom: '1px solid #ccc'
  },
  nextText: {
    margin: 0,
    fontFamily: 'Verizon-Bold'
  },
  viewAllButton: {
    margin: 0,
    fontFamily: 'Verizon-Bold'
  },
  rightArrow: {
    marginLeft: '.5rem',
    marginTop: '1px'
  },
  thumbnail: {
    width: '100%'
  },
  nextVideoWrapper: {
    position: 'relative'
  },
  thumbnailOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    zIndex: 10
  },
  nextDemoText: {
    color: '#fff',
    fontFamily: 'Verizon-Bold',
    fontSize: '1.25rem'
  }
}))
